import { USER_URL } from '../../../common/constants/user-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { UserPayload } from '../user-profile.interface';
import { getAppFlow } from '../utils/user-profile.util';

export async function putUserProfile(userData: UserPayload) {
  const url = new URL(USER_URL);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Flow': getAppFlow()
      },
      body: JSON.stringify(userData),
    })
  );
}
